// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let AssetTradingMode = { Delivery: 0, General: 1, All: 2 }

export let CalculationMethod = { Last: 0, PrevClose: 1 }